import { useEffect, useState } from "react";
import { getConnectionKeys } from "../services/connectionKeysService";

const useFetchConnectionKeysAll = ({
  setIsLoading,
  shouldFetch = false, // Default to false to prevent unintended API calls
}: any) => {
  const [connectionKeysData, setConnectionKeysData] = useState<any[]>([]);
  useEffect(() => {
    // Only fetch if shouldFetch is true
    if (!shouldFetch) {
      setConnectionKeysData([]);
      return;
    }

    const getConnectionKeysData = async () => {
      setIsLoading(true);
      try {
        const result = await getConnectionKeys();
        const res = result && result.reverse();
        setConnectionKeysData(res);
      } catch (err) {
        setConnectionKeysData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getConnectionKeysData();
  }, [shouldFetch]); // ✅ Removed setIsLoading to prevent infinite loops

  return [connectionKeysData];
};

export default useFetchConnectionKeysAll;
